// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const DashboardsGlobalList    = lazy(() => import('../../views/dashboardsglobal/list'))

const DashboardsGlobal = [
  {
    path: 'dashboardsglobal/list',
    element: <DashboardsGlobalList />
  }
]

export default DashboardsGlobal
